/* eslint-disable */

import React, { Component } from "react";
import {
  Popover,
  OverlayTrigger,
} from "react-bootstrap";
import {
  Tooltip,
  Button,
  CircularProgress,
  circularProgressClasses,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  OutlinedInput,
  Box,
  Menu,
  Checkbox,
} from "@mui/material";
import { CSSTransition } from "react-transition-group";
import { config } from "../../constants";
import * as Icon from "react-feather";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import LoadingBar from "react-top-loading-bar";
import moment from "moment-timezone";
import WithRouter from "../../HOC/RouterWrapper";
import WorkflowVisualiser from "./workflows/WorkflowVisualiser";
import _ from "lodash";
import { useAuth, useTenantsState } from "../../auth/workosAuth";
import SearchJobs from "./SearchJobs";

import { ReactComponent as TimeIcon } from "../../assets/img/icons/workflow-time.svg";
import { ReactComponent as StateIcon } from "../../assets/img/icons/workflow-state.svg";
import { ReactComponent as RefreshIcon } from "../../assets/img/icons/refresh.svg";
import { ReactComponent as DetailsIcon } from "../../assets/img/icons/details.svg";
import { ReactComponent as PausedIcon } from "../../assets/img/icons/pause.svg";
import { ReactComponent as StopIcon } from "../../assets/img/icons/StopIcon.svg";
import { ReactComponent as CancelIcon } from "../../assets/img/icons/CancelIcon.svg";
import { ReactComponent as SettingsIcon } from "../../assets/img/icons/SettingsIcon.svg";
import { ReactComponent as PlayIcon } from "../../assets/img/icons/PlayIcon.svg";
import { ReactComponent as PausingIcon } from "../../assets/img/icons/PausingIcon.svg";
import { ReactComponent as OptionsIcon } from "../../assets/img/icons/OptionsIcon.svg";
import { ReactComponent as FailedIcon } from "../../assets/img/icons/failed.svg";
import { ReactComponent as SuccessIcon } from "../../assets/img/icons/success.svg";
import { ReactComponent as QueuedIcon } from "../../assets/img/icons/queed.svg";
import runningIcon from "../../assets/img/icons/running.json";
import Lottie from "lottie-react";

import "../../styles/table.css";
import HorizontalDropdownMenu from "../../components/global/HorizontalDropdown";
import DagHistory from "./DagHistory";
import DagEdit from "./DagEdit";
import Table from "../../components/global/Table";
import TablePagination from "../../components/global/Table/Pagination";
import TableTooltip from "../../components/global/Table/Tooltip";
import {
  deleteWorkflowService,
  editWorkflowService,
  fetchDagsService,
  fetchVisualizationsService,
  rerunWorkflowService,
  stopDagService,
  togglePauseService,
  triggerWorkflowService,
  triggerFromFailureService,
} from "../../services/overview";
import DeleteConnectorModal from "../../components/Modals/DeleteConnector";
import TriggerFromFailureModal from "../../components/Modals/TriggerFromFailure";
import Dropdown from "../../components/global/Dropdown"

const TenantContextComponent = (props) => {
  const { user } = useAuth();
  const { tenants } = useTenantsState();
  if (!user) return null;
  const activeTenant = tenants.find((t) => t.tenantId === user.tenantId);
  return <Overview {...props} activeTenant={activeTenant} user={user} />;
};

var customer_timezone = localStorage.getItem("timezone");

class Overview extends Component {
  constructor(props) {
    super(props);

    this.thRefs = Array(10)
      .fill()
      .map(() => React.createRef());
    this.debouncedHandleResize = _.debounce(this.handleResize, 300);

    this.state = {
      loading: false,
      historical_runs_available: false,
      EditOpen: false,
      DAGs: [],
      running_dags: [],
      loading_metadata: true,
      modal_delete_workflow: false,
      modal_lose_workflow_progress: false,
      modal_trigger_from_failure: false,
      selected_workflow_for_trigger: null,
      dags_loading: [],
      creating_viz: false,
      loading_workflows: true,
      workflows_count: 0,
      workflows: [],
      dag_runs: [],
      last_succesful_runs: {},
      workflow_chain: [{ dependencies: [] }],
      historical_dag_runs: [],
      progress: 40,
      activeTab: "Workflows",
      selected_job: "",
      modal_edit: false,
      schedule_frequency: false,
      schedule_details: false,
      scheduling: false,
      modal_logs: false,
      schedule_day: false,
      creating_workflow: false,
      selected_job_logo: "",
      selected_job_type: "",
      active_dag_id_list: [],
      active_dag_data: {},
      active_dag_loading: false,
      active_dag_error_msg: null,
      active_dag_child_process_id_list: [],
      workflowsFilters: [],
      jobNameFilters: "",
      modal_workflow: false,
      modal_edit_workflow: false,
      new_workflows_chain: [],
      current_workflows_chain: [],
      isWorkflowBuilderShown: false,
      workflowBuilderType: "",
      dagsSorting: null, // {type, sorterSource}
      visulaizeHeaderText: "",
      shouldUpdateWorkflowStatuses: false,
      currentPage: 1,
      perPage: 10,
      isShowingDagHistoryTable: false,
      isShowingDagEdit: false,
      skips: false,
      sortedColumn: {
        column: "",
        isAsc: true,
      },
      isSearchOpen: false,
      filters: {
        frequency: [],
        status: [],
        created_by: [],
        data_source: [],
      },
      isFilterPanelOpen: false,
      bulkActionsAnchorEl: null,
      selectedDAGs: [],
      dataSources: [],
      dataSourceSearchTerm: "",
    };
  }

  setdbturl = () => {
    const localUrl = "http://127.0.0.1:5000";
    const dbtUrl = config.url.DBT_URL;
    const sqlEditorUrl = config.url.SQL_EDITOR_URL;

    const waitForTenant = setInterval(() => {
      if (this.props.activeTenant?.name) {
        clearInterval(waitForTenant);
        const finalDbtUrl =
          dbtUrl === localUrl
            ? localUrl
            : `${dbtUrl}/${this.props.activeTenant.name}`;
        const finalSqlEditorUrl =
          sqlEditorUrl === localUrl
            ? localUrl
            : `${sqlEditorUrl}/${this.props.activeTenant.name}`;
        this.setState({
          dbt_url: finalDbtUrl,
          sql_editor_url: finalSqlEditorUrl
        });
        // Note: fetchDbtRuns and fetchSelectables are only needed in Editor.js, not Overview.js
      }
    }, 500); // Check every 100ms
  };

  toggleHistoryDagTable = () => {
    this.setState({
      isShowingDagHistoryTable: !this.state.isShowingDagHistoryTable,
    });
  };

  handleResize = () => {
    setTimeout(() => {
      this.setState({
        thLogoWidth: document.getElementById("th-logo")
          ? document.getElementById("th-logo").offsetWidth
          : 0,
        thNameWidth: document.getElementById("th-name")
          ? document.getElementById("th-name").offsetWidth
          : 0,
        thWorkflowsWidth: document.getElementById("th-workflows")
          ? document.getElementById("th-workflows").offsetWidth
          : 0,
        thTypeWidth: document.getElementById("th-type")
          ? document.getElementById("th-type").offsetWidth
          : 0,
        thFrequencyWidth: document.getElementById("th-frequency")
          ? document.getElementById("th-frequency").offsetWidth
          : 0,
        thStartWidth: document.getElementById("th-start")
          ? document.getElementById("th-start").offsetWidth
          : 0,
        thEndWidth: document.getElementById("th-end")
          ? document.getElementById("th-end").offsetWidth
          : 0,
        thStatusWidth: document.getElementById("th-status")
          ? document.getElementById("th-status").offsetWidth
          : 0,
        thNextWidth: document.getElementById("th-next")
          ? document.getElementById("th-next").offsetWidth
          : 0,
        thActionsWidth: document.getElementById("th-actions")
          ? document.getElementById("th-actions").offsetWidth
          : 0,
      });
    }, 300);
  };

  detachObserver() {
    this.thRefs.forEach((ref, index) => {
      if (ref.current && this.resizeObservers[index]) {
        this.resizeObservers[index].unobserve(ref.current);
      }
    });
  }

  observeTableWidths() {
    if (!("ResizeObserver" in window)) {
      console.warn("Browser does not support ResizeObserver");
      return;
    }

    this.resizeObservers = this.thRefs.map((ref, index) => {
      if (ref.current) {
        const observer = new ResizeObserver(this.debouncedHandleResize);
        observer.observe(ref.current);
        return observer; // Store this observer instance to unobserve later
      }
      return null;
    });
  }

  componentDidMount() {
    const workflow_name = new URLSearchParams(window.location.search).get(
      "workflow"
    );

    const historyModal = new URLSearchParams(window.location.search).get(
      "history_modal"
    );

    const dagEdit = new URLSearchParams(window.location.search).get("dag_edit");
    
    const statusFilter = new URLSearchParams(window.location.search).get("status");
    if (statusFilter) {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          status: [statusFilter]
        }
      }));
    }

    if (workflow_name) {
      this.redirectToVisualization();
    } else {
      this.fetchTablesData().then(() => {
        if (historyModal && this.getTargetDAGData()) {
          this.toggleHistoryDagTable();
        }

        if (dagEdit) {
          const workflow = this.state.workflows.find(
            (item) => item.workflowname === dagEdit
          );

          this.setState({
            advanced_settings: workflow.advanced_settings,
          });
        }
      });
      this.observeTableWidths();
      this.setState({
        originalFetch: true,
        isShowingDagEdit: !!dagEdit,
        selected_edit_dag: dagEdit,
      });
    }
    this.setdbturl();
  }

  componentDidUpdate(prevProps, prevState) {
    const hasQueryParamsChanged =
      this?.props?.router?.location &&
      prevProps?.router?.location &&
      this.props.router.location.search !== prevProps.router.location.search;

    const hasInitialHistoryModalView =
      prevProps.router.location.search.includes("history_modal") ||
      this.props.router.location.search.includes("history_modal");

    const workflow_name = new URLSearchParams(window.location.search).get(
      "workflow"
    );
    const dagEdit = new URLSearchParams(window.location.search).get("dag_edit");
    
    const statusFilter = new URLSearchParams(window.location.search).get("status");
    const prevStatusFilter = new URLSearchParams(prevProps.router.location.search).get("status");
    
    if (statusFilter !== prevStatusFilter) {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          status: statusFilter ? [statusFilter] : []
        }
      }));
    }

    const routedFromWorkflowVisualizer =
      !workflow_name &&
      prevProps.router.location.search.includes("workflow") &&
      !this.state.originalFetch;

    if (hasQueryParamsChanged) {
      if (hasInitialHistoryModalView) {
        this.showInitialHistoryModal(prevProps);
      }

      if (workflow_name) {
        this.redirectToVisualization();
      } else {
        this.setState({
          isWorkflowBuilderShown: false,
          current_workflows_chain: [],
        });
      }

      this.setState({
        isShowingDagEdit: !!dagEdit,
        selected_edit_dag: dagEdit,
      });

      if (routedFromWorkflowVisualizer) {
        this.fetchTablesData();
        this.observeTableWidths();
        this.setState({
          isWorkflowBuilderShown: false,
          current_workflows_chain: [],
          originalFetch: true,
        });
      }
    }
    if (!prevState.DAGs.length && this.state.DAGs.length) {
      if (this.getTargetDAGData()) {
        this.toggleHistoryDagTable();
      }
    }

    // setTimeout(() => {
    //   document.body.style.overflow = "";
    // }, 500);

    if (
      this.state.activeTab &&
      this.state.activeTab !== "Workflows" &&
      this.state.DAGs.length &&
      !this.state?.thNameWidth
    ) {
      this.observeTableWidths();
    }
  }

  redirectToHistoryModalView = (DAG) => {
    this.props.router.navigate(
      `/jobs/overview?history_modal=${DAG.workflowname}`
    );
  };

  redirectToVisualization = async () => {
    const workflow_name = new URLSearchParams(window.location.search).get(
      "workflow"
    );

    const workflow_type = new URLSearchParams(window.location.search).get(
      "workflow_type"
    );

    if (workflow_name && this.state.current_workflows_chain.length === 0) {
      this.visualiseFlow(workflow_type, workflow_name);
      await this.fetchInitialCrucialVisualizationData();
      this.setState({
        current_workflows_chain:
          this.state?.workflows?.find(
            (workflow) => workflow.workflowname === workflow_name
          )?.workflow_chain || [],
      });
    }
  };

  fetchInitialCrucialVisualizationData = async () => {
    this.setState({ workflows: [], loading_workflows: true });

    const response = await fetchVisualizationsService();
    let isRunning = false;

    if (response) {
      this.setState({
        workflows_count: response.data["workflows"].length,
        workflows: response.data["workflows"],
      });

      response.data["workflows"].forEach((workflow) => {
        if (
          workflow.state === "running" ||
          workflow.state === "queued" ||
          workflow.state === "Scheduling..."
        )
          isRunning = true;
      });

      if (isRunning && !this.pollingInterval) {
        this.pollingInterval = setInterval(() => {
          this.fetchDAGs(true);
        }, 10000); // 10 seconds interval
      } else if (!isRunning && this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }

    this.setState({
      loading_metadata: true,
      progress: 100,
      loading: false,
      deleting: false,
      loading_workflows: false,
    });
  };

  getTargetDAGData = () => {
    const history_modal = new URLSearchParams(window.location.search).get(
      "history_modal"
    );
    const targetDAG = this.state.workflows.find(
      (DAG) => DAG.workflowname === history_modal
    );
    return targetDAG;
  };

  showInitialHistoryModal = (prevProps) => {
    //prevProps to extract queryParams from pervious render
    if (
      prevProps.router.location.search.includes("history_modal") &&
      !this.props.router.location.search.includes("history_modal")
    ) {
      this.setState({
        historical_runs_available: false,
        modal_history: false,
        isShowingDagHistoryTable: false,
      });
    }

    if (
      !prevProps.router.location.search.includes("history_modal") &&
      this.props.router.location.search.includes("history_modal")
    ) {
      if (this.getTargetDAGData()) {
        this.toggleHistoryDagTable();
      }
    }
  };

  fetchTablesData = async () => {
    this.setState({ progress: 70 });
    let height = document.documentElement.clientHeight;
    this.setState({ height: height * 0.7 });
    await this.fetchDAGs();

    if (this.state.active_dag_id_list.length) {
      this.state.active_dag_id_list.forEach((dag) => {
        this.refreshJobDetails(dag);
      });
    }
  };

  componentWillUnmount = () => {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    this.detachObserver();
    this.debouncedHandleResize.cancel(); // Ensure debounce is cancelled on unmount
  };

  toggleEditModal = (DAG) => {
    this.setState({ selected_job: DAG, modal_edit: !this.state.modal_edit });
  };

  toggleDeleteWorkflow = (dag_name,dag_id) => {
    this.setState({
      selected_dag: dag_name,
      selected_dag_id: dag_id,
      modal_delete_workflow: !this.state.modal_delete_workflow,
    });
  };

  stopDAG = async (dag_id) => {
    console.log("Stopping DAG with dag_id", dag_id);
    const dag = this.state.workflows?.find(
      (workflow) => workflow.dag_id === dag_id
    );
    console.log("DAG", dag);
    let dag_status = dag.state;
    let dag_alias = dag.workflowname;

    if (dag_status !== "running" && dag_status !== "queued") {
      toast.info(dag_alias + " is not running.");
      return;
    }
    this.setState({ stopping: true });
    this.setState({ progress: 80 });
    await stopDagService(dag_id, dag_alias);
    this.setState({ progress: 100, stopping: false });
  };

  fetchDAGs = async (
    triggeredByInterval = false,
    triggeredByDagEdit = false
  ) => {
    if (!triggeredByInterval) {
      this.setState({ loading_workflows: true, workflows: [] });
    }
    const response = await fetchDagsService();

    if (response) {
      // Store current sort state before updating
      const currentSort = this.state.sortedColumn;
      let newWorkflows = response.data["workflows"];
      
      // Re-apply sort if one exists
      if (currentSort && currentSort.column) {
        newWorkflows = [...newWorkflows].sort((a, b) => {
          const column = currentSort.column;
          const isAsc = currentSort.isAsc;
          
          if (column === "duration") {
            if (isAsc) {
              return Number(a[column]) < Number(b[column]) ? 1 : -1;
            } else {
              return Number(b[column]) < Number(a[column]) ? 1 : -1;
            }
          }
          if (isAsc) {
            return a[column]?.toLowerCase() < b[column]?.toLowerCase() ? 1 : -1;
          } else {
            return b[column]?.toLowerCase() < a[column]?.toLowerCase() ? 1 : -1;
          }
        });
      }
      
      this.setState({
        workflows_count: response.data["workflows"].length,
        workflows: newWorkflows,
        dataWarehouses: response.data["compute_wh_list"],
        queueOptions: response.data["queue_list"],
        dataSources: response.data["data_sources"] || [],
      });
      let isRunning = false;
      response.data["workflows"].forEach((workflow) => {
        if (
          workflow.state === "running" ||
          workflow.state === "queued" ||
          workflow.state === "Scheduling..."
        ) {
          console.log(workflow.workflowname, " is running, pinging again...");
          isRunning = true;
        }
      });

      if (isRunning && !this.pollingInterval) {
        this.pollingInterval = setInterval(() => {
          this.fetchDAGs(true);
        }, 10000); // 10 seconds interval
      } else if (!isRunning && this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }

      // **Add the following block to update `advanced_settings`**
      if (
        this.state.isShowingDagEdit &&
        this.state.selected_edit_dag &&
        triggeredByDagEdit
      ) {
        const updatedWorkflow = response.data["workflows"].find(
          (item) => item.workflowname === this.state.selected_edit_dag
        );
        if (updatedWorkflow) {
          this.setState({
            advanced_settings: updatedWorkflow.advanced_settings,
          });
        }
      }
    }

    this.setState({
      deleting: false,
      loading_workflows: false,
      progress: 100,
      loading: false,
    });
  };

  deleteWorkflow = async () => {
    this.setState({ deleting: true });

    const isSuccess = await deleteWorkflowService(this.state.selected_dag,this.state.selected_dag_id);

    if (isSuccess) {
      this.setState({ modal_delete_workflow: false });
      this.fetchDAGs(true);
    }
    this.setState({ deleting: false });
  };

  isTableLoading = () => {
    const isDagsRuns = typeof this.state?.dag_runs === "object";
    const dagsRunsLength = isDagsRuns
      ? Object.keys(this.state.dag_runs).length
      : 0;

    if (this.state?.activeTab === "Workflows") {
      return this.state.loading || this.state.loading_workflows;
    } else {
      return (
        this.state.loading ||
        (this.state?.DAGs?.length < 10
          ? dagsRunsLength !== this.state?.DAGs?.length
          : dagsRunsLength < 10)
      );
    }
  };

  triggerWorkflow = async (workflow_name, dag_id) => {
    // Find the workflow to check its state
    const workflow = this.state.workflows.find(w => w.dag_id === dag_id);
    
    if (workflow && workflow.state === "failed_exclude_for_now") {
      // Show modal for failed workflows
      this.setState({
        modal_trigger_from_failure: true,
        selected_workflow_for_trigger: {
          workflow_name,
          dag_id,
          dag_run_id: workflow.dag_run_id // Assuming this field exists
        }
      });
    } else {
      // Normal trigger for non-failed workflows
      const isSuccess = await triggerWorkflowService(workflow_name, dag_id);

      if (isSuccess) {
        if (this.state.isWorkflowBuilderShown) {
          this.setState({ shouldUpdateWorkflowStatuses: 10000 });
        }
        this.fetchDAGs(true);
      }
    }
  };
  
  handleTriggerFull = async () => {
    const { workflow_name, dag_id } = this.state.selected_workflow_for_trigger;
    this.setState({ modal_trigger_from_failure: false });
    
    const isSuccess = await triggerWorkflowService(workflow_name, dag_id);
    
    if (isSuccess) {
      if (this.state.isWorkflowBuilderShown) {
        this.setState({ shouldUpdateWorkflowStatuses: 10000 });
      }
      this.fetchDAGs(true);
    }
  };
  
  handleTriggerFromFailure = async () => {
    const { workflow_name, dag_id, dag_run_id } = this.state.selected_workflow_for_trigger;
    this.setState({ modal_trigger_from_failure: false });
    
    const isSuccess = await triggerFromFailureService(dag_id, dag_run_id, workflow_name);
    
    if (isSuccess) {
      if (this.state.isWorkflowBuilderShown) {
        this.setState({ shouldUpdateWorkflowStatuses: 10000 });
      }
      this.fetchDAGs(true);
    }
  };

  togglePause = async (workflowname, dag_id, paused_status) => {
    const isSuccess = await togglePauseService(
      workflowname,
      dag_id,
      !paused_status
    );

    if (isSuccess) this.fetchDAGs(true);
  };

  filterJobNames = (workflow) => {
    if (!this.state.jobNameFilters) {
      return true;
    }

    return workflow.workflowname
      .toLowerCase()
      .includes(this.state.jobNameFilters.toLowerCase());
  };

  updateWorkflowFilters = (filters) =>
    this.setState({ workflowsFilters: filters });

  filterWorkflows = (DAG) => {
    if (this.state.workflowsFilters.length) {
      const dagLists = this.state.dags_per_workflow[DAG.id];
      if (!dagLists) return false;
      if (
        dagLists.filter((target) =>
          this.state.workflowsFilters.includes(target)
        ).length
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  filterByColumn = (DAG, column, values) => {
    if (column === "data_source") {
      if (!values.length) return true;
      
      // Check if any of the selected data source schemas are present in the DAG's workflow_chain
      const dagChain = DAG.workflow_chain || [];
      const selectedSchemas = values.map(alias => {
        const dataSource = this.state.dataSources?.find(ds => ds.alias === alias);
        return dataSource ? dataSource.destination_schema : null;
      }).filter(Boolean);
      
      // Check if any task in the DAG chain references any of the selected schemas
      return dagChain.some(task => {
        const taskName = task.dag || '';
        return selectedSchemas.some(schema => taskName.includes(schema));
      });
    }
    
    return !values.length || values.includes(DAG[column]);
  };

  toggleFilter = (columnName, values) => {
    this.setState({filters: {...this.state.filters, [columnName]: values}, currentPage: 1}, () => {
      // Auto-select DAGs that match the current filters
      this.autoSelectFilteredDAGs();
    });
  }

  autoSelectFilteredDAGs = () => {
    // Get all DAGs that match current filters (same logic as used in render for display)
    const filteredWorkflows = this.state.workflows
      .filter(this.filterJobNames)
      .filter((DAG) => this.filterWorkflows(DAG) && 
        this.filterByColumn(DAG, "frequency", this.state.filters.frequency) &&
        this.filterByColumn(DAG, "created_by", this.state.filters.created_by) && 
        this.filterByColumn(DAG, "state", this.state.filters.status) &&
        this.filterByColumn(DAG, "data_source", this.state.filters.data_source || []));
    
    // Get workflow objects that match ALL current filters
    const filteredWorkflowObjects = filteredWorkflows.map(w => ({workflowname: w.workflowname, dag_id: w.dag_id, dag_alias: w.dag_alias}));
    

    
    // Replace selections with only DAGs that match current filter combination
    this.setState({
      selectedDAGs: filteredWorkflowObjects
    });
  }

  renderStatusIcon = (status) => {
    if (status === "failed" || status === "cancelled") {
      return <FailedIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "success") {
      return <SuccessIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "queued") {
      return <QueuedIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "running" || status === "waiting") {
      return (
        <Lottie
          animationData={runningIcon}
          loop
          style={{ width: "16px", height: "16px" }}
        />
      );
    } else {
      return null;
    }
  }

  handleBulkActionsClick = (event) => {
    this.setState({ bulkActionsAnchorEl: event.currentTarget });
  }

  handleBulkActionsClose = () => {
    this.setState({ bulkActionsAnchorEl: null });
  }

  handleBulkTriggerDAGs = async () => {
    this.handleBulkActionsClose();
    for (const dag of this.state.selectedDAGs) {
      await this.triggerWorkflow(dag.workflowname, dag.dag_id);
      if (this.state.selectedDAGs.indexOf(dag) < this.state.selectedDAGs.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    }
    toast.success("All selected DAGs successfully started");
  }

  handleBulkStopDAGs = async () => {
    this.handleBulkActionsClose();
    for (const dag of this.state.selectedDAGs) {
      await this.stopDAG(dag.dag_id);
      if (this.state.selectedDAGs.indexOf(dag) < this.state.selectedDAGs.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    }
    toast.success("All selected DAGs successfully stopped");
  }

  handleSelectDAG = (workflow) => {
    this.setState(prevState => ({
      selectedDAGs: prevState.selectedDAGs.some(dag => dag.dag_id === workflow.dag_id)
        ? prevState.selectedDAGs.filter(dag => dag.dag_id !== workflow.dag_id)
        : [...prevState.selectedDAGs, {workflowname: workflow.workflowname, dag_id: workflow.dag_id, dag_alias: workflow.dag_alias}]
    }));
  }

  handleSelectAllDAGs = (filteredWorkflows) => {
    const allFilteredIds = filteredWorkflows.map(w => w.dag_id);
    const allSelected = allFilteredIds.every(id => this.state.selectedDAGs.some(dag => dag.dag_id === id));
    
    if (allSelected) {
      // Unselect all filtered DAGs
      this.setState(prevState => ({
        selectedDAGs: prevState.selectedDAGs.filter(dag => !allFilteredIds.includes(dag.dag_id))
      }));
    } else {
      // Select all filtered DAGs
      const newSelections = filteredWorkflows
        .filter(w => !this.state.selectedDAGs.some(dag => dag.dag_id === w.dag_id))
        .map(w => ({workflowname: w.workflowname, dag_id: w.dag_id, dag_alias: w.dag_alias}));
      this.setState(prevState => ({
        selectedDAGs: [...prevState.selectedDAGs, ...newSelections]
      }));
    }
  }

  hasWorkflowUpdated = () => {
    const originalWorkflow = [...this.state.current_workflows_chain].map(
      (workflow) => ({
        dag: workflow.dag,
        dependencies: workflow.dependencies,
        position: {
          x: workflow?.position?.x ? parseFloat(workflow.position.x) : 0,
          y: workflow?.position?.y ? parseFloat(workflow.position.y) : 0,
        },
      })
    );
    const newWorkflow = [...this.state.new_workflows_chain];

    if (newWorkflow.length === 0) {
      return false;
    }

    if (_.isEqual(newWorkflow, originalWorkflow)) {
      return false;
    } else {
      return true;
    }
  };

  handleTabClick = (type) => {
    if (
      this.hasWorkflowUpdated() &&
      this.state.isWorkflowBuilderShown &&
      this.state.workflowBuilderType === "visualize"
    ) {
      this.submitVisualization();
    } else if (this.hasWorkflowUpdated() && this.state.isWorkflowBuilderShown) {
      this.showLoseWorkflowProgressModal();
    } else {
      this.setState({
        isWorkflowBuilderShown: false,
        active_dag_id_list: [],
        active_dag_data: {},
        active_dag_loading: false,
        active_dag_error_msg: null,
        active_dag_child_process_id_list: [],
        isShowingDagHistoryTable: false,
      });
      this.props.router.navigate("/jobs/overview");
      this.updateActiveTab(type);
    }
  };

  handleCloseWorkflow = () => {
    if (this.hasWorkflowUpdated() && this.state.isWorkflowBuilderShown) {
      this.showLoseWorkflowProgressModal();
    } else {
      this.setState({
        isWorkflowBuilderShown: false,
        modal_lose_workflow_progress: false,
        new_workflows_chain: [],
        current_workflows_chain: [],
        modal_edit_workflow: false,
        modal_workflow: false,
      });
      this.props.router.navigate("/jobs/overview");
    }
  };

  showLoseWorkflowProgressModal = () => {
    this.setState({ modal_lose_workflow_progress: true });
    document.activeElement.blur();
  };

  updateActiveTab = (type) => {
    switch (type) {
      case "Workflows":
        this.setState({
          activeTab: "Workflows",
          dag_id: false,
          workflowsFilters: [],
          jobNameFilters: [],
        });
        break;
      case "Jobs":
        this.setState({
          activeTab: "Jobs",
          dag_id: false,
          workflowsFilters: [],
          jobNameFilters: [],
        });
        break;

      default:
        this.setState({ workflowsFilters: [], jobNameFilters: [] });
        break;
    }
  };

  renderWorkFlowPlayButton = (workflow) => {
    // FIXME:
    const user = this.props.user;
    if (["max@datajolt.i", "rob@datajolt.i"].includes(user?.email)) {
      return (
        <Dropdown>
          <Dropdown.Button
            endIcon={undefined}
            sx={{
              width: "26px",
              height: "26px",
              borderRadius: "50%",
              backgroundColor: "rgb(243, 243, 243)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              "&:hover": {
                backgroundColor: "rgb(243, 243, 243)",
              }
            }}
          >
            {workflow.state == "running" || workflow.state == "queued" ? (
              <CircularProgress size={16} sx={{ color: "#2c49fc" }} />
            ) : (
              <PlayIcon />
            )}
          </Dropdown.Button>
          <Dropdown.Menu>
            <Dropdown.MenuItem
              disabled={
                workflow.state == "running" ||
                workflow.state == "queued" ||
                workflow.state == "Scheduling..."
              }
              onClick={async (e) => {
                e.stopPropagation();
                await rerunWorkflowService(workflow.workflowname);
              }}
            >
              Rerun DAG from failure
            </Dropdown.MenuItem>
            <Dropdown.MenuItem
              disabled={
                workflow.state == "running" ||
                workflow.state == "queued" ||
                workflow.state == "Scheduling..."
              }
              onClick={(e) => {
                e.stopPropagation();
                this.triggerWorkflow(workflow.workflowname, workflow.dag_id);
              }}
            >
              Trigger DAG
            </Dropdown.MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      );
    } else {
      if (!workflow) return;
      return (
        <MenuItem sx={{ padding: 0 }}>
          <Tooltip title="Trigger DAG" placement="bottom">
            <Button
              size="sm"
              variant="no-outline-success"
              disabled={
                workflow.state == "running" ||
                workflow.state == "queued" ||
                workflow.state == "Scheduling..." && workflow.frequency !== "Relative"
              }
              onClick={(e) => {
                e.stopPropagation();
                this.triggerWorkflow(workflow.workflowname, workflow.dag_id);
              }}
              sx={{
                minWidth: 0,
                padding: 0,
                borderRadius: "50%",
                width: "26px",
                height: "26px",
                backgroundColor: "#f3f3f3",
                transition: "all ease",

                "&:disabled": {
                  cursor: "not-allowed !important",
                  opacity: 0.2,
                },

                "&:hover": {
                  backgroundColor: "#2c49fc",
                  color: "#f3f3f3",

                  "& svg, & svg *": {
                    fill: "#f3f3f3",
                  },
                },

                [`& svg:not(.${circularProgressClasses.svg})`]: {
                  width: "12px",
                  height: "12px",
                  fill: "#2c49fc",
                  transition: "all ease",

                  "&.bigger-svg": {
                    width: "17px",
                    height: "17px",
                  },
                },
              }}
            >
              {workflow.state == "running" ||
              workflow.state == "queued" ||
              workflow.state == "Scheduling..." && workflow.frequency !== "Relative" ? (
                <CircularProgress size={14} sx={{ color: "#2c49fc" }} />
              ) : (
                <PlayIcon />
              )}
            </Button>
          </Tooltip>
        </MenuItem>
      );
    }
  };

  toggleEditWorkflow = (workflow_name = "") => {
    this.setState({
      isWorkflowBuilderShown: true,
      workflowBuilderType: "edit",
      workflow_name: workflow_name,
      modal_edit_workflow: !this.state.modal_workflow,
      current_workflows_chain:
        this.state?.workflows?.find(
          (workflow) => workflow.workflowname === workflow_name
        )?.workflow_chain || [],
    });
  };

  toggleCreateWorkflow = () => {
    this.setState({
      modal_workflow: true,
      new_workflows_chain: [],
      isWorkflowBuilderShown: true,
      workflowBuilderType: "create",
      isShowingDagHistoryTable: false,
    });
    this.props.router.navigate("/jobs/overview");
  };

  handleNewWorkflowClose = () => {
    if (this.state.new_workflows_chain.length) {
      toast.error("you didn't save your DAG");
      this.setState({ modal_lose_workflow_progress: true });
    } else {
      this.setState({ new_workflows_chain: [], modal_workflow: false });
    }
  };

  handleEditWorkflowClose = () => {
    if (this.state.new_workflows_chain.length) {
      toast.error("you didn't save your DAG");
      this.setState({ modal_lose_workflow_progress: true });
    } else {
      this.setState({
        new_workflows_chain: [],
        current_workflows_chain: [],
        modal_edit_workflow: false,
        new_workflows_chain: [],
        modal_workflow: false,
      });
    }
  };

  submitVisualization = async () => {
    if (this.state.isVisualizingDBT) {
      //WIP
      // axios
      //   .post(api_url + "/api/workflows/get_DBT_model", {
      //     workflow_name: visualize_name,
      //     workflowChain: this.state.new_workflows_chain,
      //   })
      //   .then((response) => {
      //     const DBT_workflow_chain = response.data.workflow_chain;
      //     this.setState({
      //       isWorkflowBuilderShown: true,
      //       workflowBuilderType: "visualize",
      //       visulaizeHeaderText,
      //       current_workflows_chain: DBT_workflow_chain,
      //     });
      //   })
      //   .catch((err) => {
      //     toast.error("Error visualising your DBT model");
      //   })
      //   .finally(() => {
      //     this.setState({ creating_viz: false });
      //   });

      console.log("submitting DBT MODEL");
    } else {
      await this.editWorkflow(
        this.state.workflow_name,
        false,
        "Saving your nodes position...'"
      );
      this.props.router.navigate("/jobs/overview");
      this.fetchDAGs();
    }
  };

  visualiseFlow = (
    task_level,
    visualize_name,
    last_run_started,
    state,
    dag_id
  ) => {
    if (task_level == 1) {
      //TBD the new DBT model status api
      // axios
      //   .get(api_url + "/api/workflows/get_DBT_model/name")
      //   .then((response) => {
      //     const DBT_workflow_chain = response.data.workflow_chain;
      //     this.setState({
      //       isWorkflowBuilderShown: true,
      //       workflowBuilderType: "visualize",
      //       visulaizeHeaderText,
      //       current_workflows_chain: DBT_workflow_chain,
      //     });
      //   })
      //   .catch((err) => {
      //     toast.error("Error visualising your DBT model");
      //   })
      //   .finally(() => {
      //     this.setState({ creating_viz: false });
      //   });
      //   this.setState({
      //     isWorkflowBuilderShown: true,
      //     workflowBuilderType: "visualize",
      //     visulaizeHeaderText,
      //     current_workflows_chain: [],
      //     workflow_name: visualize_name,
      //     isVisualizingDBT: task_level,
      //   });
    } else {
      this.setState({
        isWorkflowBuilderShown: true,
        workflowBuilderType: "visualize",
        isVisualizingDBT: parseInt(task_level) || 0,
        workflow_name: visualize_name,
        selected_dag_id: dag_id,
      });
    }
  };

  hasCycle = (node, visited, stack, graph) => {
    visited[node] = true;
    stack[node] = true;

    const neighbors = graph[node] || [];
    for (let neighbor of neighbors) {
      if (!visited[neighbor]) {
        if (this.hasCycle(neighbor, visited, stack, graph)) {
          return true;
        }
      } else if (stack[neighbor]) {
        return true;
      }
    }

    stack[node] = false;
    return false;
  };

  checkCircularReference = (data) => {
    const graph = {};
    data.forEach((item) => {
      graph[item.dag] = item.dependencies;
    });

    const visited = {};
    const stack = {};

    for (let node in graph) {
      if (!visited[node]) {
        if (this.hasCycle(node, visited, stack, graph)) {
          return true;
        }
      }
    }
    return false;
  };

  editWorkflow = async (
    workflow_name,
    shouldRefetchDAGs = true,
    toastText = "Editing your DAG..."
  ) => {
    this.setState({ creating_workflow: true });
    if (this.state.new_workflows_chain.length < 2) {
      toast.error("Chain at least two tasks to create a DAG.", {
        autoClose: 5000,
      });
      this.setState({ creating_workflow: false });
    } else if (this.checkCircularReference(this.state.new_workflows_chain)) {
      toast.error("Please remove the circular reference in your DAG", {
        autoClose: 5000,
      });
      this.setState({ creating_workflow: false });
    } else {
      const isSuccess = await editWorkflowService(
        toastText,
        this.state.new_workflows_chain,
        workflow_name
      );

      if (isSuccess) {
        this.setState({
          modal_workflow: false,
          modal_edit_workflow: false,
          new_workflows_chain: [],
          workflow_name: "",
          current_workflows_chain: [],
          isWorkflowBuilderShown: false,
          progress: 100,
        });
        if (shouldRefetchDAGs) {
          this.fetchDAGs();
        }
      }

      this.setState({ progress: 100, creating_workflow: false });
      this.props.router.navigate("/jobs/overview");
    }
  };

  updateWorkflowsData = (updatedWorkflows) =>
    this.setState({ new_workflows_chain: updatedWorkflows });

  compareTimestamps = (a, b) => {
    const { type, sorterSource } = this.state.dagsSorting;
    const timestampA = a[sorterSource];
    const timestampB = b[sorterSource];

    if (type === "ascending") {
      return new Date(timestampA) - new Date(timestampB);
    } else if (type === "descending") {
      return new Date(timestampB) - new Date(timestampA);
    }
  };

  sortedDagsList = () => {
    if (this.state.dagsSorting && this.state.DAGs && this.state.dag_runs) {
      const dagsList = [...this.state.DAGs].map((DAG) => ({
        ...DAG,
        start_date:
          this.state.dag_runs[DAG.id]?.[0]?.start_date || '"2000-07-02 08:00',
        end_date:
          this.state.dag_runs[DAG.id]?.[0]?.end_date || '"2000-07-02 08:00',
      }));

      return dagsList.slice().sort(this.compareTimestamps);
    } else {
      return this.state.DAGs;
    }
  };

  updateSortingOptions = (sorterSource, sortingType) => {
    const sortingDetails = this.state.dagsSorting;
    if (!sortingDetails) {
      // initial sort no active sort
      this.setState({ dagsSorting: { type: sortingType, sorterSource } });
    } else {
      if (
        sortingDetails.type === sortingType &&
        sortingDetails.sorterSource === sorterSource
      ) {
        this.setState({ dagsSorting: null });
      } else {
        this.setState({ dagsSorting: { type: sortingType, sorterSource } });
      }
    }
  };

  renderSortIndicator = (sorterSource) => {
    const sortingDetails = this.state.dagsSorting;

    return (
      <div>
        <Icon.ArrowUp
          size={14}
          onClick={() => this.updateSortingOptions(sorterSource, "ascending")}
          color={
            sortingDetails?.sorterSource === sorterSource &&
            sortingDetails?.type === "ascending"
              ? "blue"
              : "#879fb5"
          }
        />

        <Icon.ArrowDown
          size={14}
          onClick={() => this.updateSortingOptions(sorterSource, "descending")}
          color={
            sortingDetails?.sorterSource === sorterSource &&
            sortingDetails?.type === "descending"
              ? "blue"
              : "#879fb5"
          }
        />
      </div>
    );
  };

  calculateTotalPages = () => {
    const DAGSlist = this.state.workflows;
    const currentActiveTable = this.state.activeTab;

    // Use the same filtering logic as in render for consistent pagination
    const filteredLength = DAGSlist
      .filter(this.filterJobNames)
      .filter((DAG) => this.filterWorkflows(DAG) && 
        this.filterByColumn(DAG, "frequency", this.state.filters.frequency) &&
        this.filterByColumn(DAG, "created_by", this.state.filters.created_by) && 
        this.filterByColumn(DAG, "state", this.state.filters.status) &&
        this.filterByColumn(DAG, "data_source", this.state.filters.data_source || [])).length;

    const totalLength =
      currentActiveTable === "Workflows"
        ? filteredLength
        : DAGSlist.filter((DAG) => {
            if (currentActiveTable === "Jobs") {
              return true;
            } else {
              return true;
              // FIXME: this will return error, as workflows doesn't have type, and there isn't a key called "activeType" in state
              // return DAG.type.toLowerCase() == this.state.activeType;
            }
          })
            .filter((DAG) => this.filterJobNames(DAG))
            .filter((DAG) => this.filterWorkflows(DAG)).length;

    return totalLength ? Math.ceil(totalLength / this.state.perPage) : 1;
  };

  paginateArray = (
    array,
    activePage = this.state.currentPage,
    perPageCount = this.state.perPage
  ) => {
    const startIndex = (activePage - 1) * perPageCount;
    const endIndex = startIndex + perPageCount;

    return array.slice(startIndex, endIndex);
  };

  onSortColumn = (column) => {
    const workflows = this.state.workflows.map((workflow) => ({ ...workflow }));
    let isAsc = true;

    if (this.state.sortedColumn.column === column) {
      isAsc = !this.state.sortedColumn.isAsc;
    }

    this.setState({
      workflows: workflows.sort((a, b) => {
        if (column === "duration") {
          // this condetion can be enhaned to check if both entitis are numbers and we can provide a proper condetion for such casses
          if (isAsc) {
            return Number(a[column]) < Number(b[column]) ? 1 : -1;
          } else {
            return Number(b[column]) < Number(a[column]) ? 1 : -1;
          }
        }
        if (isAsc) {
          return a[column]?.toLowerCase() < b[column]?.toLowerCase() ? 1 : -1;
        } else {
          return b[column]?.toLowerCase() < a[column]?.toLowerCase() ? 1 : -1;
        }
      }),
    });
    this.setState({ sortedColumn: { column, isAsc } });
  };

  render() {
    const { navigate } = this.props.router;
    const isViewingVisualizationLink = new URLSearchParams(
      window.location.search
    ).get("workflow");
    


    // Apply filters to get the complete filtered dataset
    const filteredWorkflows = this.state.workflows
      .filter(this.filterJobNames)
      .filter((DAG) => this.filterWorkflows(DAG) && 
        this.filterByColumn(DAG, "frequency", this.state.filters.frequency) &&
        this.filterByColumn(DAG, "created_by", this.state.filters.created_by) && 
        this.filterByColumn(DAG, "state", this.state.filters.status) &&
        this.filterByColumn(DAG, "data_source", this.state.filters.data_source || []));
    
    // Get the paginated version for table display
    const paginatedWorkflows = this.paginateArray(filteredWorkflows);
    
    return (
      <div
        id={`overview${
          this.state.isWorkflowBuilderShown
            ? "-" + this.state.workflowBuilderType + "-workflow"
            : "-viewer"
        }`}
        className="container-fluid py-3"
      >
        <LoadingBar color="#0245a0" progress={this.state.progress} />
        <Helmet title="Datajolt | Scheduled DAGs" />

        {!this.state.isWorkflowBuilderShown && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "12px 8px",
              height: "45px",
            }}
          >
            <h4 style={{ margin: 0, width: "260px" }}>
              <b style={{ color: "#090E47" }}>
              My Scheduled DAGs {!this.state.loading_workflows && `(${this.state.workflows_count})`}              </b>
              <OverlayTrigger
                trigger="click"
                placement="bottom"
                overlay={
                  <Popover id={`popover-positioned-bottom`}>
                    <Popover.Header as="h3">{"What are DAGs ?"}</Popover.Header>
                    <Popover.Body>
                      DAGs are jobs running on a specific cadence. They are
                      orchestrating your data flows.
                    </Popover.Body>
                  </Popover>
                }
              >
                <Button sx={{ minWidth: 0, padding: "0.25rem 0.7rem" }}>
                  <DetailsIcon />
                </Button>
              </OverlayTrigger>{" "}
            </h4>
            <div
              style={{
                display: "flex",
                marginLeft: "auto",
                alignItems: "center",
                gap: 10,
              }}
            >
              <Tooltip title="Refresh Jobs" placement="bottom">
                <div
                  className="me-1 mb-1 mr-2"
                  disabled={this.state.loading}
                  onClick={() => this.fetchDAGs()}
                >
                  {" "}
                  {this.state.loading ? (
                    <CircularProgress size={16} sx={{ color: "#2c49fc" }} />
                  ) : (
                    <RefreshIcon />
                  )}
                </div>
              </Tooltip>
            </div>
          </div>
        )}

        {!this.state.isWorkflowBuilderShown && !isViewingVisualizationLink && (
          <>
            <hr
              style={{
                margin: "0 8px",
              }}
            />
            {!this.state.loading &&
            !this.state.loading_workflows &&
            this.state.workflows.length == 0 ? (
              <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                padding: '60px 40px',
                textAlign: 'center',
                marginLeft: '8px',
                marginRight: '8px',
              }}>
                <div style={{
                  marginBottom: '16px',
                }}>
                  <Icon.Clock size={48} color="#6c757d" />
                </div>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#293042',
                  margin: '0 0 8px 0',
                  fontFamily: "'Poppins', sans-serif",
                }}>No {this.state.activeTab == "Workflows" ? "DAGs" : this.state.activeTab.toLowerCase()} yet</h3>
                <p style={{
                  fontSize: '14px',
                  color: '#6c757d',
                  margin: '0',
                  fontFamily: "'Poppins', sans-serif",
                }}>Schedule your first {this.state.activeTab == "Workflows" ? "DAG" : this.state.activeTab.toLowerCase()} to get started</p>
              </div>
            ) : (
              <>
                {/* Add this new filter panel section */}
                <div style={{ margin: "8px 8px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px", flexWrap: "wrap", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                      {/* Search DAG */}
                      <Box 
                        sx={{ 
                          width: "200px",
                          "& .MuiOutlinedInput-root": {
                            height: "32px",
                            minHeight: "32px"
                          },
                          "& .MuiInputBase-input": {
                            height: "32px",
                            padding: "0 14px",
                            lineHeight: "32px"
                          },
                          "& .MuiFormControl-root": {
                            height: "32px"
                          }
                        }}
                      >
                        <SearchJobs
                          onFilterChange={(filters) => this.setState({ jobNameFilters: filters, currentPage: 1 }, () => {
                            this.autoSelectFilteredDAGs();
                          })}
                          filter={this.state.jobNameFilters}
                          isSearchOpen={true}
                          toggleSearch={() => {}}
                          placeholder="Search DAGs..."
                          size="small"
                        />
                      </Box>

                      {/* Frequency Filter */}
                      <FormControl size="small" sx={{ minWidth: 140 }}>
                        <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Frequency</InputLabel>
                        <Select
                          multiple
                          value={this.state.filters.frequency}
                          onChange={(e) => this.toggleFilter("frequency", e.target.value)}
                          input={<OutlinedInput label="Frequency" />}
                          renderValue={() => this.state.filters.frequency.length > 0 ? `Frequency (${this.state.filters.frequency.length})` : "Frequency"}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 400,
                                marginTop: 4,
                                padding: 0,
                                overflow: 'hidden',
                              },
                              sx: {
                                '& .MuiList-root': {
                                  padding: 0,
                                  overflow: 'auto',
                                  maxHeight: 400,
                                }
                              }
                            },
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left',
                            },
                          }}
                          sx={{ 
                            maxWidth: 160,
                            fontSize: "10px",
                            fontWeight: 400,
                            "& .MuiSelect-select": {
                              fontSize: "10px",
                              fontWeight: 400
                            }
                          }}
                        >
                          {/* Loading Spinner */}
                          {this.state.loading_workflows && (
                            <MenuItem disabled sx={{ 
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "40px 16px",
                              fontSize: "10px",
                              fontWeight: 400,
                              color: "#6b7280"
                            }}>
                              <div style={{ 
                                display: "flex", 
                                flexDirection: "column", 
                                alignItems: "center", 
                                gap: "12px" 
                              }}>
                                <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                <span>Loading frequencies...</span>
                              </div>
                            </MenuItem>
                          )}
                          
                          {!this.state.loading_workflows && Array.from(new Set(this.state.workflows.map(w => w.frequency))).map(freq => (
                            <MenuItem key={freq} value={freq} sx={{ fontSize: "10px", fontWeight: 400, wordBreak: "break-all" }}>
                              {freq}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* Status Filter */}
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Status</InputLabel>
                        <Select
                          multiple
                          value={this.state.filters.status}
                          onChange={(e) => this.toggleFilter("status", e.target.value)}
                          input={<OutlinedInput label="Status" />}
                          renderValue={() => this.state.filters.status.length > 0 ? `Status (${this.state.filters.status.length})` : "Status"}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 400,
                                marginTop: 4,
                                padding: 0,
                                overflow: 'hidden',
                              },
                              sx: {
                                '& .MuiList-root': {
                                  padding: 0,
                                  overflow: 'auto',
                                  maxHeight: 400,
                                }
                              }
                            },
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left',
                            },
                          }}
                          sx={{ 
                            maxWidth: 140,
                            fontSize: "10px",
                            fontWeight: 400,
                            "& .MuiSelect-select": {
                              fontSize: "10px",
                              fontWeight: 400
                            }
                          }}
                        >
                          {/* Loading Spinner */}
                          {this.state.loading_workflows && (
                            <MenuItem disabled sx={{ 
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "40px 16px",
                              fontSize: "10px",
                              fontWeight: 400,
                              color: "#6b7280"
                            }}>
                              <div style={{ 
                                display: "flex", 
                                flexDirection: "column", 
                                alignItems: "center", 
                                gap: "12px" 
                              }}>
                                <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                <span>Loading statuses...</span>
                              </div>
                            </MenuItem>
                          )}
                          
                          {!this.state.loading_workflows && Array.from(new Set(this.state.workflows.map(w => w.state))).map(status => (
                            <MenuItem key={status} value={status} sx={{ 
                              fontSize: "10px", 
                              fontWeight: 400, 
                              wordBreak: "break-all",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center"
                            }}>
                              <span>{status}</span>
                              {this.renderStatusIcon(status)}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* Owner Filter */}
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Owner</InputLabel>
                        <Select
                          multiple
                          value={this.state.filters.created_by}
                          onChange={(e) => this.toggleFilter("created_by", e.target.value)}
                          input={<OutlinedInput label="Owner" />}
                          renderValue={() => this.state.filters.created_by.length > 0 ? `Owner (${this.state.filters.created_by.length})` : "Owner"}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 400,
                                marginTop: 4,
                                padding: 0,
                                overflow: 'hidden',
                              },
                              sx: {
                                '& .MuiList-root': {
                                  padding: 0,
                                  overflow: 'auto',
                                  maxHeight: 400,
                                }
                              }
                            },
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left',
                            },
                          }}
                          sx={{ 
                            maxWidth: 140,
                            fontSize: "10px",
                            fontWeight: 400,
                            "& .MuiSelect-select": {
                              fontSize: "10px",
                              fontWeight: 400
                            }
                          }}
                        >
                          {/* Loading Spinner */}
                          {this.state.loading_workflows && (
                            <MenuItem disabled sx={{ 
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "40px 16px",
                              fontSize: "10px",
                              fontWeight: 400,
                              color: "#6b7280"
                            }}>
                              <div style={{ 
                                display: "flex", 
                                flexDirection: "column", 
                                alignItems: "center", 
                                gap: "12px" 
                              }}>
                                <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                <span>Loading owners...</span>
                              </div>
                            </MenuItem>
                          )}
                          
                          {!this.state.loading_workflows && Array.from(new Set(this.state.workflows.map(w => w.created_by))).map(owner => (
                            <MenuItem key={owner} value={owner} sx={{ fontSize: "10px", fontWeight: 400, wordBreak: "break-all" }}>
                              {owner}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* Data Sources Filter */}
                      <FormControl size="small" sx={{ minWidth: 140 }}>
                        <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Data Sources</InputLabel>
                        <Select
                          multiple
                          value={this.state.filters.data_source || []}
                          onChange={(e) => this.toggleFilter("data_source", e.target.value)}
                          input={<OutlinedInput label="Data Sources" />}
                          renderValue={() => (this.state.filters.data_source || []).length > 0 ? `Data Sources (${(this.state.filters.data_source || []).length})` : "Data Sources"}
                          onOpen={() => this.setState({ dataSourceSearchTerm: "" })}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 400,
                                marginTop: 4,
                                padding: 0,
                                overflow: 'hidden',
                              },
                              sx: {
                                '& .MuiList-root': {
                                  padding: 0,
                                  overflow: 'auto',
                                  maxHeight: 400,
                                }
                              }
                            },
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left',
                            },
                          }}
                          sx={{ 
                            maxWidth: 160,
                            fontSize: "10px",
                            fontWeight: 400,
                            "& .MuiSelect-select": {
                              fontSize: "10px",
                              fontWeight: 400
                            }
                          }}
                        >
                          {/* Search Input - Sticky (always show if not loading) */}
                          {!this.state.loading_workflows && (
                            <Box
                              sx={{
                                position: "sticky",
                                top: 0,
                                zIndex: 1001,
                                backgroundColor: "white",
                                borderBottom: "1px solid #e0e0e0",
                                padding: "8px 16px",
                                margin: 0,
                                marginTop: 0,
                                marginBottom: 0,
                                boxSizing: "border-box",
                                transform: "translateZ(0)", // Force hardware acceleration for smoother scrolling
                              }}
                              onClickCapture={(e) => e.stopPropagation()}
                            >
                              <Box 
                                sx={{ 
                                  width: "100%",
                                  position: "relative",
                                  "& .MuiOutlinedInput-root": {
                                    height: "32px",
                                    minHeight: "32px",
                                    backgroundColor: "white"
                                  },
                                  "& .MuiInputBase-input": {
                                    height: "32px",
                                    padding: "0 14px 0 32px",
                                    lineHeight: "32px",
                                    fontSize: "10px",
                                    color: "#374151",
                                    "&::placeholder": {
                                      color: "#9ca3af",
                                      opacity: 1
                                    }
                                  },
                                  "& .MuiFormControl-root": {
                                    height: "32px"
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#d1d5db"
                                  },
                                  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#9ca3af"
                                  },
                                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#3b82f6",
                                    borderWidth: "1px"
                                  }
                                }}
                              >
                                <Icon.Search 
                                  size={16} 
                                  style={{
                                    position: "absolute",
                                    left: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#9ca3af",
                                    zIndex: 1
                                  }}
                                />
                                <OutlinedInput
                                  placeholder="Search data sources..."
                                  value={this.state.dataSourceSearchTerm}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    this.setState({ dataSourceSearchTerm: e.target.value });
                                  }}
                                  onKeyDown={(e) => e.stopPropagation()}
                                  size="small"
                                  sx={{ width: "100%" }}
                                />
                              </Box>
                            </Box>
                          )}

                          {/* Loading Spinner */}
                          {this.state.loading_workflows && (
                            <MenuItem disabled sx={{ 
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "40px 16px",
                              fontSize: "10px",
                              fontWeight: 400,
                              color: "#6b7280"
                            }}>
                              <div style={{ 
                                display: "flex", 
                                flexDirection: "column", 
                                alignItems: "center", 
                                gap: "12px" 
                              }}>
                                <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                <span>Loading data sources...</span>
                              </div>
                            </MenuItem>
                          )}
                          
                          {/* Filtered Data Sources */}
                          {!this.state.loading_workflows && (this.state.dataSources || [])
                            .filter(dataSource => 
                              dataSource.alias.toLowerCase().includes(this.state.dataSourceSearchTerm.toLowerCase())
                            )
                            .map(dataSource => (
                              <MenuItem key={dataSource.alias} value={dataSource.alias} sx={{ 
                                fontSize: "10px", 
                                fontWeight: 400, 
                                wordBreak: "break-all",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "8px 16px",
                                "&:hover": {
                                  backgroundColor: "#f5f5f5"
                                }
                              }}>
                                <span style={{ flex: 1 }}>{dataSource.alias}</span>
                                {dataSource.logo && (
                                  <img 
                                    src={dataSource.logo} 
                                    alt={dataSource.alias} 
                                    style={{ 
                                      width: "20px", 
                                      height: "20px", 
                                      marginLeft: "8px",
                                      borderRadius: "2px",
                                      objectFit: "contain"
                                    }}
                                  />
                                )}
                              </MenuItem>
                            ))}
                          
                          {/* No results message */}
                          {!this.state.loading_workflows && this.state.dataSourceSearchTerm && 
                           (this.state.dataSources || [])
                             .filter(dataSource => 
                               dataSource.alias.toLowerCase().includes(this.state.dataSourceSearchTerm.toLowerCase())
                             ).length === 0 && (
                            <MenuItem disabled sx={{ 
                              fontSize: "10px", 
                              fontWeight: 400,
                              fontStyle: "italic",
                              color: "#999",
                              padding: "8px 16px"
                            }}>
                              No data sources found
                            </MenuItem>
                          )}

                          {/* No data sources available */}
                          {!this.state.loading_workflows && (!this.state.dataSources || this.state.dataSources.length === 0) && (
                            <MenuItem disabled sx={{ 
                              fontSize: "10px", 
                              fontWeight: 400,
                              fontStyle: "italic",
                              color: "#999",
                              padding: "8px 16px",
                              justifyContent: "center"
                            }}>
                              No data sources available
                            </MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </div>

                    {/* Selected count and Bulk Actions */}
                    {this.state.selectedDAGs.length > 0 && (
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontSize: "10px", fontWeight: 400, color: "#6b7280" }}>
                          {this.state.selectedDAGs.length} DAG(s) selected
                        </span>
                        <Button
                          variant="contained"
                          onClick={this.handleBulkActionsClick}
                          sx={{
                            backgroundColor: "#2563eb",
                            color: "white",
                            fontSize: "11px",
                            fontWeight: 500,
                            height: "32px",
                            padding: "0 16px",
                            textTransform: "none",
                            borderRadius: "6px",
                            "&:hover": {
                              backgroundColor: "#1d4ed8"
                            }
                          }}
                        >
                          Bulk actions
                        </Button>
                      </div>
                    )}
                    
                    {/* Bulk Actions Menu */}
                    <Menu
                      anchorEl={this.state.bulkActionsAnchorEl}
                      open={Boolean(this.state.bulkActionsAnchorEl)}
                      onClose={this.handleBulkActionsClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem onClick={this.handleBulkTriggerDAGs} sx={{ 
                        fontSize: "10px", 
                        fontWeight: 400,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}>
                        <span>Trigger DAGs</span>
                        <div style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "#f3f3f3",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}>
                          <PlayIcon style={{ width: "10px", height: "10px", fill: "#2c49fc" }} />
                        </div>
                      </MenuItem>
                      <MenuItem onClick={this.handleBulkStopDAGs} sx={{ 
                        fontSize: "10px", 
                        fontWeight: 400,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}>
                        <span>Stop DAGs</span>
                        <div style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "#f3f3f3",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}>
                          <StopIcon style={{ width: "10px", height: "10px", fill: "#2c49fc" }} />
                        </div>
                      </MenuItem>
                    </Menu>
                  </div>

                  {/* Active Filters */}
                  {(this.state.filters.frequency.length + this.state.filters.status.length + this.state.filters.created_by.length + (this.state.filters.data_source?.length || 0) + (this.state.jobNameFilters ? 1 : 0)) > 0 && (
                    <div style={{ marginBottom: "16px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                        <span style={{ fontSize: "10px", fontWeight: 400 }}>Active filters:</span>
                        
                        {this.state.jobNameFilters && (
                          <span style={{
                            backgroundColor: "#eff6ff",
                            color: "#1d4ed8",
                            padding: "4px 8px",
                            borderRadius: "16px",
                            fontSize: "10px",
                            fontWeight: 400,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}>
                            DAG Name: {this.state.jobNameFilters}
                            <Icon.X 
                              size={14} 
                              style={{ cursor: "pointer" }} 
                              onClick={() => this.setState({ jobNameFilters: "", currentPage: 1 })}
                            />
                          </span>
                        )}
                        
                        {this.state.filters.frequency.map(freq => (
                          <span key={freq} style={{
                            backgroundColor: "#eff6ff",
                            color: "#1d4ed8",
                            padding: "4px 8px",
                            borderRadius: "16px",
                            fontSize: "10px",
                            fontWeight: 400,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}>
                            Frequency: {freq}
                            <Icon.X 
                              size={14} 
                              style={{ cursor: "pointer" }} 
                              onClick={() => this.toggleFilter("frequency", this.state.filters.frequency.filter(f => f !== freq))}
                            />
                          </span>
                        ))}
                        
                        {this.state.filters.status.map(status => (
                          <span key={status} style={{
                            backgroundColor: "#eff6ff",
                            color: "#1d4ed8",
                            padding: "4px 8px",
                            borderRadius: "16px",
                            fontSize: "10px",
                            fontWeight: 400,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}>
                            Status: {status}
                            <Icon.X 
                              size={14} 
                              style={{ cursor: "pointer" }} 
                              onClick={() => this.toggleFilter("status", this.state.filters.status.filter(s => s !== status))}
                            />
                          </span>
                        ))}
                        
                        {this.state.filters.created_by.map(owner => (
                          <span key={owner} style={{
                            backgroundColor: "#eff6ff",
                            color: "#1d4ed8",
                            padding: "4px 8px",
                            borderRadius: "16px",
                            fontSize: "10px",
                            fontWeight: 400,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}>
                            Owner: {owner}
                            <Icon.X 
                              size={14} 
                              style={{ cursor: "pointer" }} 
                              onClick={() => this.toggleFilter("created_by", this.state.filters.created_by.filter(o => o !== owner))}
                            />
                          </span>
                        ))}

                        {(this.state.filters.data_source || []).map(alias => (
                          <span key={alias} style={{
                            backgroundColor: "#eff6ff",
                            color: "#1d4ed8",
                            padding: "4px 8px",
                            borderRadius: "16px",
                            fontSize: "10px",
                            fontWeight: 400,
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                          }}>
                            Data Source: {alias}
                            <Icon.X 
                              size={14} 
                              style={{ cursor: "pointer" }} 
                              onClick={() => this.toggleFilter("data_source", (this.state.filters.data_source || []).filter(s => s !== alias))}
                            />
                          </span>
                        ))}
                        
                        <Button
                          variant="text"
                          size="small"
                          onClick={() => this.setState({ 
                            filters: { frequency: [], status: [], created_by: [], data_source: [] },
                            jobNameFilters: "",
                            currentPage: 1,
                            selectedDAGs: []
                          })}
                          sx={{ fontSize: "10px", fontWeight: 400, color: "#6b7280" }}
                        >
                          Clear all
                        </Button>
                      </div>
                    </div>
                  )}
                </div>

                {this.state.activeTab == "Workflows" && (
                  <Table
                    headings={[
                      {
                        width: "4%",
                        Children: () => (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                            <Checkbox
                              size="small"
                              checked={filteredWorkflows.length > 0 && filteredWorkflows.every(w => this.state.selectedDAGs.some(dag => dag.dag_id === w.dag_id))}
                              indeterminate={filteredWorkflows.some(w => this.state.selectedDAGs.some(dag => dag.dag_id === w.dag_id)) && !filteredWorkflows.every(w => this.state.selectedDAGs.some(dag => dag.dag_id === w.dag_id))}
                              onChange={() => this.handleSelectAllDAGs(filteredWorkflows)}
                              sx={{ padding: 0 }}
                            />
                          </div>
                        ),
                        columnName: "select",
                        isSortable: false,
                      },
                      {
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            DAG name{children}
                          </span>
                        ),
                        isSortable: true,
                        columnName: "workflowname",
                      },
                      {
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            Frequency
                            {children}
                          </span>
                        ),
                        columnName: "frequency",
                        isSortable: true,
                      },
                      {
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            Last run started
                            {children}
                          </span>
                        ),
                        columnName: "started_at",
                        isSortable: true,
                      },
                      {
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            Last run ended
                            {children}
                          </span>
                        ),
                        columnName: "ended_at",
                        isSortable: true,
                      },
                      {
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            Duration
                            {children}
                          </span>
                        ),
                        columnName: "duration",
                        isSortable: true,
                      },
                      {
                        Children: ({children}) => 
                          <span className="d-flex align-items-center h-100">
                            status
                            {children}
                          </span>,
                        columnName: "status",
                        isSortable: false,
                      },
                      {
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            Next run
                            {children}
                          </span>
                        ),
                        columnName: "next_run",
                        isSortable: true,
                      },
                      {
                        Children: ({ children }) => (
                          <span className="d-flex align-items-center h-100">
                            Owner
                            {children}
                          </span>
                        ),
                        columnName: "created_by",
                        isSortable: true,
                      },
                      {
                        width: "6%",
                        Children: () => "Actions",
                        columnName: "actions",
                        isSortable: false,
                      },
                    ]}
                    rows={paginatedWorkflows.map((workflow) => ({
                      key: `${workflow.workflowname}-${workflow.dag_id}`,
                      style: {
                        cursor: this.state.workflows_metadata
                          ? "pointer"
                          : "unset",
                      },
                      onClick: () => {
                        if (this.state.workflows && workflow.allow_edits) {
                          this.visualiseFlow(
                            0,
                            workflow.workflowname,
                            workflow.started_at,
                            workflow.state,
                            workflow.dag_id
                          );
                          navigate(
                            `/jobs/overview?workflow=${workflow.workflowname}&workflow_type=0`
                          );
                        }
                        else {
                          toast.info("This is a custom DAG. Visualization is not available.");
                        }
                      },
                      columns: [
                        {
                          type: "component",
                          component: (
                            <div 
                              onClick={(e) => {
                                e.stopPropagation();
                                this.handleSelectDAG(workflow);
                              }}
                              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', cursor: 'pointer' }}
                            >
                              <Checkbox
                                size="small"
                                checked={this.state.selectedDAGs.some(dag => dag.dag_id === workflow.dag_id)}
                                onChange={() => {}}
                                sx={{ padding: 0, pointerEvents: 'none' }}
                              />
                            </div>
                          ),
                        },
                        {
                          type: "text",
                          text: workflow.workflowname,
                        },
                        {
                          type: "text",
                          text: workflow.frequency,
                        },
                        {
                          type: "date",
                          date: workflow.started_at,
                        },
                        {
                          type: "date",
                          date: workflow.ended_at,
                        },
                        {
                          type: "text",
                          text: workflow.duration
                            ? Math.round(workflow.duration) + " min"
                            : "",
                        },
                        {
                          type: "status",
                          key: workflow.state,
                        },
                        {
                          type: "text",
                          text: workflow.paused ? (
                            <PausedIcon className="centered-svg-block" />
                          ) : workflow.next_run ? (
                            moment
                              .utc(workflow.next_run)
                              .tz(customer_timezone)
                              ?.format("YYYY-MM-DD HH:mm")
                          ) : (
                            ""
                          ),
                        },
                        {
                          type: "text",
                          text: workflow.created_by,
                        },
                        {
                          type: "component",
                          component: (
                            <HorizontalDropdownMenu
                              items={[
                                {
                                  tooltipTitle: !workflow.paused ? "Pause" : "Unpause",
                                  variant: workflow.paused
                                    ? "secondary"
                                    : "no-outline",
                                  className: "me-1 mb-1",
                                  disabled: this.state.pausing,
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    this.togglePause(
                                      workflow.workflowname,
                                      workflow.dag_id,
                                      workflow.paused
                                    );
                                  },
                                  children: <PausingIcon />,
                                },
                                {
                                  tooltipTitle: "History",
                                  variant: "no-outline",
                                  className: "me-1 mb-1",
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    this.redirectToHistoryModalView(workflow);
                                  },
                                  children: <OptionsIcon />,
                                },
                                {
                                  tooltipTitle: "Edit",
                                  variant: "no-outline",
                                  className: "mb-1",
                                  disabled:
                                    !this.state.workflows ||
                                    !workflow.allow_edits,
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    this.setState({
                                      isShowingDagEdit: true,
                                      selected_edit_dag:
                                        workflow.workflowname,
                                      advanced_settings:
                                        workflow.advanced_settings,
                                    });
                                    navigate(
                                      `/jobs/overview?dag_edit=${workflow.workflowname}`
                                    );
                                  },
                                  children: (
                                    <SettingsIcon className="bigger-svg" />
                                  ),
                                },
                                {
                                  tooltipTitle: "Stop",
                                  variant: "no-outline-danger",
                                  className: "mb-1 me-1",
                                  disabled: false,
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    this.stopDAG(workflow.dag_id);
                                  },
                                  children: <StopIcon />,
                                },
                                {
                                  tooltipTitle: "Delete",
                                  variant: "no-outline-danger",
                                  className: "mb-1",
                                  disabled: false,
                                  onClick: (e) => {
                                    e.stopPropagation();
                                    this.toggleDeleteWorkflow(
                                      workflow.workflowname,
                                      workflow.dag_id
                                    );
                                  },
                                  children: <CancelIcon />,
                                },
                              ]}
                            >
                              {this.renderWorkFlowPlayButton(workflow)}
                            </HorizontalDropdownMenu>
                          ),
                        },
                      ],
                    }))}
                    sortedColumn={this.state.sortedColumn}
                    onSortColumn={this.onSortColumn}
                    isLoading={this.isTableLoading()}
                  />
                )}
                <TablePagination
                  currentPage={this.state.currentPage}
                  totalPages={this.calculateTotalPages()}
                  updatePageNum={(num) => this.setState({ currentPage: num })}
                  updatePerPage={(num) => this.setState({ perPage: num })}
                  activeTable={`${this.state.activeTab}-${this.state?.jobNameFilters}-${this.state?.workflowsFilters?.length}`}
                />
              </>
            )}
          </>
        )}

        {isViewingVisualizationLink && !this.state.isWorkflowBuilderShown && (
          <div className="card-body">
            <div
              className="card"
              style={{
                minHeight: "500px",
                height: "689px",
                background: "rgb(243, 243, 243)",
                border: "1px solid #ccc",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <>
                  <center>
                    <CircularProgress size={16} sx={{ color: "#2c49fc" }} />
                  </center>
                  <br />
                </>
              </div>
            </div>
          </div>
        )}

        {this.state.isWorkflowBuilderShown &&
          this.state.workflowBuilderType === "visualize" && (
            <div className="card-body workflow-vis-wrapper">
              <div className="card vis-wrapper">
                <header className="vis-header">
                  <>
                    <small
                      style={{
                        fontWeight: 500,
                        fontSize: 11,
                        color: "#8488A9",
                        border: "2px solid #D0D5DD",
                        borderRadius: "7px",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px 10px",
                        height: "38px",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          backgroundColor: "#111137",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "8px",
                        }}
                      >
                        <span style={{ fontSize: "16px", color: "#FFFFFF" }}>
                          🚀
                        </span>
                      </div>
                      <b style={{ marginBottom: 0, color: "#090e47" }}>
                        {this.state.workflow_name}
                      </b>
                    </small>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <small
                        style={{
                          fontWeight: 500,
                          fontSize: 11,
                          color: "#8488A9",
                          border: "2px solid #D0D5DD",
                          padding: "5px 10px",
                          borderRadius: "7px",
                          display: "flex",
                          alignItems: "center",
                          height: "38px",
                          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <TimeIcon />
                        <span style={{ margin: "0 3px" }} />
                        Last run: {"  "}
                        {this.state.workflows?.find(
                          (workflow) =>
                            workflow.workflowname === this.state.workflow_name
                        )?.started_at
                          ? moment
                              .utc(
                                this.state.workflows?.find(
                                  (workflow) =>
                                    workflow.workflowname ===
                                    this.state.workflow_name
                                ).started_at
                              )
                              .tz(customer_timezone)
                              ?.format("YYYY-MM-DD HH:mm")
                          : "Never"}
                        {"   "} <span style={{ margin: "0 10px" }}>||</span>{" "}
                        {"   "}
                        <StateIcon />
                        <span style={{ margin: "0 3px" }} />
                        Last run status: {"  "}
                        <span style={{ margin: "3px" }}>
                          {
                            <TableTooltip
                              status={
                                this.state.workflows?.find(
                                  (workflow) =>
                                    workflow.workflowname ===
                                    this.state.workflow_name
                                )?.state
                              }
                            />
                          }
                        </span>
                      </small>
                    </div>
                    <span style={{ display: "flex", gap: "5px" }}>
                      <Button
                        variant="contained"
                        sx={{
                          color: "white",
                          border: "1px solid #D0D5DD",
                          borderRadius: "5px",
                          background: "#27cc97",
                          padding: "5px 10px",
                          fontWeight: "500",
                          fontSize: "11px",
                          lineHeight: "25px",
                          "&:disabled": {
                            background: "#27cc97",
                            color: "white",
                          }
                        }}
                        disabled={
                          this.state.workflows?.find(
                            (workflow) =>
                              workflow.workflowname === this.state.workflow_name
                          )?.state === "running" ||
                          this.state.workflows?.find(
                            (workflow) =>
                              workflow.workflowname === this.state.workflow_name
                          )?.state === "queued"
                          || (this.state.workflows?.find(
                            (workflow) =>
                              workflow.workflowname === this.state.workflow_name
                          )?.state === "Scheduling..." && this.state.workflows?.find(
                            (workflow) =>
                              workflow.workflowname === this.state.workflow_name
                          )?.frequency != "Relative")
                        }
                        onClick={() =>
                          this.triggerWorkflow(this.state.workflow_name,this.state.selected_dag_id)
                        }
                      >
                        {this.state.workflows?.find(
                          (workflow) =>
                            workflow.workflowname === this.state.workflow_name
                        )?.state === "running" ||
                        this.state.workflows?.find(
                          (workflow) =>
                            workflow.workflowname === this.state.workflow_name
                        )?.state === "queued" || (this.state.workflows?.find(
                          (workflow) =>
                            workflow.workflowname === this.state.workflow_name
                        )?.state === "Scheduling..." && this.state.workflows?.find(
                          (workflow) =>
                            workflow.workflowname === this.state.workflow_name
                        )?.frequency !== "Relative") ? (
                          <>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <CircularProgress size={14} sx={{ color: "#fff" }} />
                            &nbsp;&nbsp;&nbsp;&nbsp;
                          </>
                        ) : (
                          <>
                            <Icon.PlayCircle
                              size={14}
                              style={{
                                marginRight: "5px",
                                marginBottom: "3px",
                              }}
                            />
                            Play
                          </>
                        )}
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          color: "white",
                          border: "1px solid #D0D5DD",
                          borderRadius: "5px",
                          background: "#E34234",
                          fontWeight: "500",
                          fontSize: "11px",
                          padding: "5px 10px",
                        }}
                        onClick={() => this.stopDAG(this.state.selected_dag_id)}
                      >
                        <Icon.StopCircle
                          size={14}
                          style={{ marginRight: "5px", marginBottom: "3px" }}
                        />
                        Stop
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          color: "white",
                          border: "1px solid #D0D5DD",
                          borderRadius: "5px",
                          background: "#abaaaa",
                          padding: "5px 10px",
                          fontWeight: "500",
                          fontSize: "11px",
                          lineHeight: "25px",
                        }}
                        onClick={() => {
                          if (
                            this.hasWorkflowUpdated() &&
                            this.state.isWorkflowBuilderShown
                          ) {
                            this.submitVisualization();
                          } else {
                            this.handleCloseWorkflow();
                          }
                        }}
                      >
                        <Icon.X
                          size={14}
                          style={{ marginRight: "5px", marginBottom: "3px" }}
                        />
                        Close
                      </Button>
                    </span>
                  </>
                </header>
                <WorkflowVisualiser
                  editorURL={this.state.sql_editor_url}
                  updateWorkflows={this.updateWorkflowsData}
                  DAGList={this.state.workflows}
                  setCurrentWorkflow={(chain) =>
                    this.setState({ current_workflows_chain: chain })
                  }
                  editWorkflow={{
                    initial_workflow_chain: this.state.current_workflows_chain,
                    workflow_name: this.state.workflow_name,
                    shouldUpdateWorkflowStatuses:
                      this.state.shouldUpdateWorkflowStatuses,
                    stopUpdaterChecker: () =>
                      this.setState({ shouldUpdateWorkflowStatuses: false }),
                    run_id:
                      this.state?.workflows_metadata &&
                      this.state?.workflows_metadata?.[
                        this.state?.workflow_name
                      ] &&
                      Object.keys(
                        this.state?.workflows_metadata?.[
                          this.state?.workflow_name
                        ]
                      )?.[0],
                  }}
                  listDags={this.fetchDAGs}
                />
              </div>
            </div>
          )}

        <DeleteConnectorModal
          isShown={this.state.modal_delete_workflow}
          onHide={() => this.setState({ modal_delete_workflow: false })}
          onAction={() => this.deleteWorkflow()}
          deleteData={{
            deleting: this.state.deleting,
          }}
          text={{
            bold: this.state.selected_dag,
            regular: "DAG",
            regularFirst: true,
          }}
        />
        
        <TriggerFromFailureModal
          isShown={this.state.modal_trigger_from_failure}
          onHide={() => this.setState({ modal_trigger_from_failure: false })}
          onTriggerFull={this.handleTriggerFull}
          onTriggerFromFailure={this.handleTriggerFromFailure}
          workflowName={this.state.selected_workflow_for_trigger?.workflow_name || ""}
        />

        <CSSTransition
          in={this.state.isShowingDagHistoryTable}
          classNames="form-tab"
          timeout={300}
          unmountOnExit
        >
          <DagHistory
            dagList={
              Boolean(this.state.workflows.length) && this.state.workflows
            }
            show_logs={true}
            onClose={() => {
              this.setState({
                isShowingDagHistoryTable: !this.state.isShowingDagHistoryTable,
              });
              navigate("/jobs/overview");
            }}
          />
        </CSSTransition>

        <CSSTransition
          in={this.state.isShowingDagEdit}
          classNames="form-tab"
          timeout={300}
          unmountOnExit
        >
          <DagEdit
            key={
              this.state.advanced_settings
                ? this.state.advanced_settings.someUniqueIdentifier
                : "initial"
            }
            editing_dag_alias={this.state.selected_edit_dag}
            advanced_settings={this.state.advanced_settings}
            onClose={() => {
              this.setState({ isShowingDagEdit: false });
              navigate("/jobs/overview");
            }}
            fetchDAGs={this.fetchDAGs}
            workflows={this.state.workflows}
            editorURL={this.state.sql_editor_url}
            dataWarehouses={this.state.dataWarehouses}
            queueOptions={this.state.queueOptions}
          />
        </CSSTransition>
      </div>
    );
  }
}

export default WithRouter(TenantContextComponent);
